module.exports = __webpack_public_path__ + "img/ph.556c697e.jpg";